import { Suspense } from 'react';
import { CompanyBankAccounts, CompanyTaxAndDuties } from '@features';
import { Grid, Skeleton, Stack } from '@mantine/core';

const SKELETON_MIN_HEIGHT = 100;

export const CompanyDetailsFinancePage: React.FC = () => {
  return (
    <Stack py="md">
      <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
        <Grid>
          <Grid.Col span={8}>
            <CompanyBankAccounts />
          </Grid.Col>
          <Grid.Col span={4}>
            <CompanyTaxAndDuties />
          </Grid.Col>
        </Grid>
      </Suspense>
    </Stack>
  );
};
